export default "__VITE_ASSET__543aead3__"